import MarketSubscription from '../views/n2n/MarketSubscription.vue';
import ProductLookup from '../views/n2n/ProductLookup.vue';
import ProductRegistration from '../views/n2n/ProductRegistration.vue';
import RemovalSetting from '../views/n2n/RemovalSetting.vue';
import Catalog from '../views/n2n/catalog.vue';

const n2nRoutes = {
  children: [
    {
      path: 'subscription',
      name: 'N2nMarketSubscription',
      component: MarketSubscription,
      meta: { module: 'n2n' }
    },
    {
      path: 'lookup',
      name: 'N2nProductLookup',
      component: ProductLookup,
      meta: { module: 'n2n' }
    },
    {
      path: 'registration',
      name: 'N2nProductRegistration',
      component: ProductRegistration,
      meta: { module: 'n2n' }
    },
    {
      path: 'removal-setting',
      name: 'N2nRemovalSetting',
      component: RemovalSetting,
      meta: { module: 'n2n' }
    },
    {
      path: 'catalog',
      name: 'N2nCatalog',
      component: Catalog,
      meta: { module: 'n2n' }
    }
  ]
};

export default n2nRoutes;

